//============================
//# rsgenobjectremark
//============================

export default interface GeneralObjectMarkTag {
  id: number;
  tableName: string;
  remark: string;
  deleted: boolean;

  inEdit: boolean;
  selected: boolean;
}

export const GeneralObjectMarkTagDefaultProps: GeneralObjectMarkTag = {
  id: 0,
  tableName: "-",
  remark: "",
  deleted: false,

  inEdit: false,
  selected: false,
}
